const PurchaseRequestRouter = [
    {
        path: "list-rental_order_sell",
        name: "list",
        component: () => import("@/views/admin/purchase_request"),
        default: true,
        meta: {
            model: "rental_order_sell",
            // requiresAuth: true,
        },
    },
    {
        path: "list-rental_order_sell/add",
        name: "add",
        component: () => import("@/views/admin/purchase_request/function"),
        default: true,
        meta: {
            model: "rental_order_sell",
            // requiresAuth: true,
        },
    },
    {
        path: "list-rental_order_sell/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/purchase_request/function"),
        default: true,
        meta: {
            model: "rental_order_sell",
            // requiresAuth: true,
        },
    },
  ];
  export default PurchaseRequestRouter;